import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for Advocate users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const AdvocateRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles="advocate" 
      redirectPath="/advocate/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default AdvocateRoute;

